<template>
  <InputDate
    :key="filtro.filtro"
    :text="text"
    :filtro="filtro"
    :campo="filtro"
    :intervalo-data="intervaloData"
    @aplicarFiltro="aplicarFiltro"
    @dateRangeSelected="onDateRangeSelected"
    @dateRangeCleared="onDateRangeCleared"
    @update:text="onUpdateText"
    :path="path"
  />
</template>
<script>
import InputDate from '../../components/InputDate.vue';
export default {
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  components: {
    InputDate
  },
  data() {
    return {
      selectedDateRange: {
        inicio: '',
        fim: ''
      },
      text: ''
    };
  },
  computed: {
    intervaloData() {
      const filtros = this.$store.state.filtroAplicados;
      return {
        inicio: filtros[`${this.filtro.filtro}_ini`] || '',
        fim: filtros[`${this.filtro.filtro}_fim`] || ''
      };
    }
  },
  watch: {
    intervaloData: {
      handler(newVal) {
        if (!newVal?.inicio || !newVal?.fim) return;

        const inicioMoment = moment(newVal.inicio, 'DD/MM/YYYY');
        const fimMoment = moment(newVal.fim, 'DD/MM/YYYY');

        if (!inicioMoment.isValid() || !fimMoment.isValid()) return;

        this.selectedDateRange = { inicio: newVal.inicio, fim: newVal.fim };
        this.text = this.formataTexto(newVal.inicio, newVal.fim);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onDateRangeSelected(data) {
      this.selectedDateRange = data;
      this.text = this.formataTexto(data.inicio, data.fim);
      this.aplicarFiltro();
    },
    onDateRangeCleared() {
      this.selectedDateRange = { inicio: '', fim: '' };
      this.text = '';
      this.$removeFiltroDaURL(`${this.filtro.filtro}_ini`, this.path);
      this.$removeFiltroDaURL(`${this.filtro.filtro}_fim`, this.path);
      this.$store.commit('removeFiltroAplicado', `${this.filtro.filtro}_ini`);
      this.$store.commit('removeFiltroAplicado', `${this.filtro.filtro}_fim`);
    },
    aplicarFiltro() {
      if (!this.selectedDateRange.inicio || !this.selectedDateRange.fim) return;

      const inicio = this.selectedDateRange.inicio.replaceAll('-', '/');
      const fim = this.selectedDateRange.fim.replaceAll('-', '/');

      this.$aplicaFiltroEmURL(`${this.filtro.filtro}_ini`, inicio, this.path);
      this.$store.commit('addFiltroAplicado', { filtro: `${this.filtro.filtro}_ini`, valor: inicio });

      this.$aplicaFiltroEmURL(`${this.filtro.filtro}_fim`, fim, this.path);
      this.$store.commit('addFiltroAplicado', { filtro: `${this.filtro.filtro}_fim`, valor: fim });
    },
    onUpdateText(text) {
      this.text = text;
    },
    formataTexto(inicio, fim) {
      const i = inicio.replaceAll('-', '/');
      const f = fim.replaceAll('-', '/');
      return i === f ? i : `${i} - ${f}`;
    }
  },
  mounted() {
    const filtros = this.$store.state.filtroAplicados;
    const inicio = filtros[`${this.filtro.filtro}_ini`];
    const fim = filtros[`${this.filtro.filtro}_fim`];

    if (inicio && fim) {
      this.selectedDateRange = { inicio, fim };
      this.text = this.formataTexto(inicio, fim);
    } else if (Object.hasOwn(filtros, this.filtro.filtro)) {
      this.text = filtros[this.filtro.filtro];
    }
  },
  beforeUnmount() {
    this.selectedDateRange = { inicio: '', fim: '' };
    this.text = '';
  }
}
</script>
